/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import IconButton from '@mui/material/IconButton';
import { Component } from 'react';

import { styles } from './styles';

class InlineOption extends Component {
	onClick() {
		const { onClick, value } = this.props;
		onClick(value);
	}

	render() {
		const Icon = this.props.icon;
		const { active } = this.props;

		return (
			<IconButton onClick={this.onClick.bind(this)} tabIndex={-1}>
				<Icon fontSize="small" sx={active ? styles.active : styles.inActive} />
			</IconButton>
		);
	}
}

export default InlineOption;
